<!-- <app-header> </app-header> -->
<!-- <router-outlet></router-outlet> -->
<app-home-banner></app-home-banner>
<app-our-services></app-our-services>
<app-why-sat></app-why-sat>
<div>
  <div class="container pt-80">
    <div class="text-center ps-5 pe-5">
      <h2 class="mb-3">Our Apps</h2>
    </div>
  </div>
  <app-home-apps></app-home-apps>
</div>

<app-latest-news></app-latest-news>
<app-sat></app-sat>
@if (isShow) {
  <button (click)="gotoTop()" class="scroll-btn">
    <i class="fa fa-chevron-up" aria-hidden="true"></i>
  </button>
}
<!-- <app-footer></app-footer> -->
